import Utils from './utils.js';

/**
 * Class Cookie Visibility
 */
export default class Cookie {

	/**
	 * Handle cookie visibility conditions.
	 * Remove "hideClass" from element if it passed the cookie validation.
	 */
	handleCookieVisibility( element, elementData, elementIsAllHide, showAllHideElement ) {

		// If item has already been shown
		if ( ! element.classList.contains( Utils.hideClass ) ) {
			return;
		}

		const cookieSettings = elementData.cookies_settings.cookies || [];

		Utils.compareRequestToSettings(
			element,
			cookieSettings,
			this.getCookies(),
			elementIsAllHide,
			showAllHideElement
		);

	}

	/**
	 * Helper function to get all the document cookies as an array of objects.
	 * for instance:
	 * [ { 'name': 'cookieName', 'value': 'cookieValue' } ]
	 *
	 * @returns {{}}
	 */
	getCookies() {
		let pairs = document.cookie.split( ";" );
		let pair;
		let cookies = [];

		pairs.forEach( ( unsplitPair ) => {
			pair = unsplitPair.split( "=" );
			cookies.push( {
				name: pair[0].toString().trim(),
				value: pair.slice( 1 ).join( '=' )
			} );
		} );

		return cookies;
	}

}
